/**
 * Shared with IntakeFooterBar so the two Continue button implementations
 * (IntakeLayout's DOM-swap footer and IntakeFooterBar's crossfade footer)
 * can't drift from each other on a future visual tweak.
 */
export const INTAKE_CONTINUE_BUTTON_CLASS =
  "flex items-center gap-2 rounded-[8px] border-0 bg-(--brand-navy) px-4 py-[9px] text-[14px] font-semibold text-white cursor-pointer hover:bg-(--steel-110) disabled:cursor-not-allowed disabled:opacity-50";
